import i18n from "../language/i18n";

export const retrieveDiscountAmountTypeOptionList = () => {
  return [
    {
      value: "PERCENTAGE",
      text: i18n.t("PERCENTAGE"),
    },
    {
      value: "FIXED_AMOUNT",
      text: i18n.t("FIXED_AMOUNT"),
    },
  ];
};

export const retrieveCurrencyTypeOptionList = () => {
  return [
    {
      value: "TRY",
      text: i18n.t("TRY"),
    },
    {
      value: "USD",
      text: i18n.t("USD"),
    },
    {
      value: "EUR",
      text: i18n.t("USD"),
    },
  ];
};
